import { render, staticRenderFns } from "./StreamWebRtc.vue?vue&type=template&id=392191b4&scoped=true"
import script from "./StreamWebRtc.vue?vue&type=script&lang=js"
export * from "./StreamWebRtc.vue?vue&type=script&lang=js"
import style0 from "./StreamWebRtc.vue?vue&type=style&index=0&id=392191b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392191b4",
  null
  
)

export default component.exports